import { render } from "./terms_of_service_panel.vue?vue&type=template&id=687e38f6"
import script from "./terms_of_service_panel.js?vue&type=script&lang=js"
export * from "./terms_of_service_panel.js?vue&type=script&lang=js"

import "./terms_of_service_panel.vue?vue&type=style&index=0&id=687e38f6&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__